/**
 * App — Single-page portfolio composition.
 *
 * Renders all sections in order and runs an IntersectionObserver reveal system
 * that fades each `.reveal` wrapper in on scroll.
 */
import './App.css';
import { useEffect } from 'react';

import Header         from './components/Header';
import Home           from './components/Home';
import About          from './components/About';
import Skills         from './components/Skills';
import RecentProjects from './components/RecentProjects';
import WorkedWith     from './components/WorkedWith';
// Reserved for a future Certificates section
// import Certificates   from './components/Certificates';
import ContactSection from './components/ContactSection';
import Footer         from './components/Footer';

function App() {
  useEffect(() => {
    const sections = document.querySelectorAll('.reveal');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target;
            el.classList.add('visible');

            // Strip reveal classes after the transition so position:fixed
            // children (modals/popups) aren't affected by the wrapper's
            // lingering opacity/transform.
            el.addEventListener('transitionend', () => {
              el.classList.remove('reveal', 'visible');
            }, { once: true });

            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.08 }
    );

    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Header />
      <main>
        <div className="reveal"><Home /></div>
        <div className="reveal"><About /></div>
        <div className="reveal"><Skills /></div>
        <div className="reveal"><RecentProjects /></div>
        <div className="reveal"><WorkedWith /></div>
        {/* Reserved for a future Certificates section */}
        {/* <div className="reveal"><Certificates /></div> */}
        <div className="reveal"><ContactSection /></div>
      </main>
      <Footer />
    </>
  );
}

export default App;